
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.5 0l1 1H14v2H0V1h3.5l1-1h5zM7 9.59l2.12-2.12 1.41 1.41L8.41 11l2.12 2.12-1.41 1.41L7 12.41l-2.12 2.12-1.41-1.41L5.59 11 3.46 8.88l1.41-1.41L7 9.59zM1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4H1v12zM11 6H3v10h8V6z"}})])
          )
        }
      }
    